import {guardarDoc} from "../BD/guardarDoc";

export const guardarFecha = async (fecha) => {

    let obj = {
        fecha: fecha ? fecha : new Date().getTime(),
        id: 'fecha'
    }


    await guardarDoc('actualizaciones', obj)


}